import { IDocumentState } from '@/store/document';
import { IDocumentMutations } from './mutations.types';
import {
  IDocumentRevisionData,
  IQuoteDocumentTagData,
  IQuoteProductDocumentData
} from '@/models';

export const mutations: IDocumentMutations = {
  SET_COUNT(state: IDocumentState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IDocumentState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IDocumentState): void {
    state.count -= 1;
  },

  SET_DOCUMENTS(
    state: IDocumentState,
    payload: IQuoteProductDocumentData[]
  ): void {
    state.documents = payload;
  },

  ADD_DOCUMENT(
    state: IDocumentState,
    payload: IQuoteProductDocumentData
  ): void {
    state.documents.unshift(payload);
  },

  UPDATE_DOCUMENT(
    state: IDocumentState,
    payload: IQuoteProductDocumentData
  ): void {
    const index = state.documents.findIndex(
      (quoteDocument: IQuoteProductDocumentData) =>
        quoteDocument.id === payload.id
    );

    state.documents.splice(index, 1, payload);
  },

  REMOVE_DOCUMENT(state: IDocumentState, payload: number): void {
    const index = state.documents.findIndex(
      (quoteDocument: IQuoteProductDocumentData) => quoteDocument.id === payload
    );

    state.documents.splice(index, 1);
  },

  SET_DOCUMENT_REVISIONS(
    state: IDocumentState,
    payload: IDocumentRevisionData[]
  ): void {
    state.documentRevisions = payload;
  },

  SET_LAST_PROMISE(state: IDocumentState, payload: Promise<any>): void {
    state.lastPromise = payload;
  },

  //Tags
  SET_QUOTE_DOCUMENT_TAGS(
    state: IDocumentState,
    payload: IQuoteDocumentTagData[]
  ): void {
    state.documentTags = payload;
  },

  ADD_QUOTE_DOCUMENT_TAG(
    state: IDocumentState,
    payload: IQuoteDocumentTagData
  ): void {
    state.documentTags.push(payload);
  },

  UPDATE_QUOTE_DOCUMENT_TAG(
    state: IDocumentState,
    payload: IQuoteDocumentTagData
  ): void {
    const index = state.documentTags.findIndex(
      (quoteDocumentTag: IQuoteDocumentTagData) =>
        quoteDocumentTag.id === payload.id
    );

    state.documentTags.splice(index, 1, payload);
  },

  REMOVE_QUOTE_DOCUMENT_TAG(state: IDocumentState, payload: number): void {
    const index = state.documentTags.findIndex(
      (quoteDocumentTag: IQuoteDocumentTagData) =>
        quoteDocumentTag.id === payload
    );

    state.documentTags.splice(index, 1);
  }
};
